import React, { useState } from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { useHistory } from 'react-router-dom'
import {
  Modal,
  Button,
  Select
} from '@arnsbogroup/react-voicearchive'
import useApi from 'hooks/useApi'
import NiceModal, { useModal } from '@ebay/nice-modal-react'

export default NiceModal.create(({ task }) => {
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const [taskType, setTaskType] = useState({value: task?.type?.uid, label: task?.type?.name})
  const modal = useModal()

  const [types] = useApi(`/rest/v2/ordertasktype?pageSize=10000`)

  const onSubmit = () => {
    if (!taskType?.value) {
      return
    }
    setLoading(true)

    fetch(`/rest/v2/task/${task.uid}`, { method: 'PUT', body: JSON.stringify({typeId: taskType?.value}) })
      .then((response) => response.json())
      .then(() => setLoading(false))
      .catch((error) => toastr.error(error))
      .finally(() => {
        modal.resolve()
        modal.remove()
      })
  }

  return (
    <Modal
      show={modal.visible}
      onClose={() => modal.remove()}
      onOutsideClick={() => modal.remove()}
      onSubmit={() => loading || task?.type?.uid == taskType.value ? undefined : onSubmit()}
      title={formatMessage(messages.title)}
      dialogPanelClasses="max-w-4xl"
    >
      <div className="space-y-2">
        <Select
          key="TaskTypeSelect"
          label={formatMessage(messages.selectTitle)}
          placeholder={formatMessage(messages.selectPlaceholder)}
          value={taskType}
          onChange={(value) => setTaskType(value)}
          options={!types ? [] : types
            .filter(({uid, shortname}) => uid != task?.type?.uid && ['LSA', 'LSP'].includes(shortname))
            .map(({uid, name}) => ({value: uid, label: name}))}
        />
        <Button
          size="sm"
          disabled={loading || task?.type?.uid == taskType.value}
          onClick={onSubmit}
        >
          { loading ? formatMessage(messages.loading) : formatMessage(messages.submit) }
        </Button>
      </div>
    </Modal>
  )
})
